import { createIconComponent } from '../../factory/create-icon-component';
export const OctogonalCrossIcon = createIconComponent(
  'OctogonalCrossIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 10.651C2 9.6726 2 9.18342 2.11052 8.72307C2.20851 8.31493 2.37012 7.92475 2.58944 7.56686C2.83681 7.16319 3.18271 6.81729 3.87452 6.12548L6.12548 3.87452C6.81729 3.18271 7.16319 2.83681 7.56686 2.58944C7.92475 2.37012 8.31493 2.20851 8.72307 2.11052C9.18342 2 9.6726 2 10.651 2H13.349C14.3274 2 14.8166 2 15.2769 2.11052C15.6851 2.20851 16.0753 2.37012 16.4331 2.58944C16.8368 2.83681 17.1827 3.18271 17.8745 3.87452L20.1255 6.12548C20.8173 6.81729 21.1632 7.16319 21.4106 7.56686C21.6299 7.92475 21.7915 8.31493 21.8895 8.72307C22 9.18342 22 9.6726 22 10.651V13.349C22 14.3274 22 14.8166 21.8895 15.2769C21.7915 15.6851 21.6299 16.0753 21.4106 16.4331C21.1632 16.8368 20.8173 17.1827 20.1255 17.8745L17.8745 20.1255C17.1827 20.8173 16.8368 21.1632 16.4331 21.4106C16.0753 21.6299 15.6851 21.7915 15.2769 21.8895C14.8166 22 14.3274 22 13.349 22H10.651C9.6726 22 9.18342 22 8.72307 21.8895C8.31493 21.7915 7.92475 21.6299 7.56686 21.4106C7.16319 21.1632 6.81729 20.8173 6.12548 20.1255L3.87452 17.8745C3.18271 17.1827 2.83681 16.8368 2.58944 16.4331C2.37012 16.0753 2.20851 15.6851 2.11052 15.2769C2 14.8166 2 14.3274 2 13.349V10.651Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 15L15 9M9 9L15 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
